export const Networks = Object.freeze({
	BITCOIN: "BITCOIN",
	TRON: "TRON",
	ETHEREUM: "ETHEREUM",
	BASE: "BASE",
	SOLANA: "SOLANA",
	LITECOIN: "LITECOIN",
	RIPPLE: "RIPPLE",
	DOGECOIN: "DOGECOIN",
	//LIGHTNING: "LIGHTNING",
});
